import { StringWithAutocomplete } from '@uplift/types';
import { restClient } from '../client';


export type NextUncompletedFormSubmissionInput = {
  form_key: StringWithAutocomplete<'UPLIFT_STANDARD' | 'PHQ9' | 'UPLIFT_STANDARD'>;
};


export type NextUncompletedFormSubmissionOutput = {
  submission_id: number;
  progress: number;
};


export const nextUncompletedFormSubmission = restClient.createRequest<NextUncompletedFormSubmissionInput, NextUncompletedFormSubmissionOutput>({
  url: '/api/v1/form/next-uncompleted-submission',
  method: 'GET',
});
